/**
 * Shell — root layout for the authenticated admin area.
 *
 * Composes Sidebar (fixed, ~240px) + Topbar (sticky header) + a main scroll
 * region rendering the active route via `<Outlet />`. Targets desktop only
 * (≥ 1024px per RNF04); mobile/responsive behavior is out of scope for v1.
 */
import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export function Shell(): ReactElement {
  return (
    <div className="flex min-h-screen bg-bg text-white">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6" id="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
